import { TypographyProps } from './typographyMixin';

export const defaultProps: Omit<TypographyProps, 'theme'> = {
  size: 'sm',
  type: 'regular',
};
